<template>
  <pt-insure-info-table :tableLabels="tableLabels" :tableData="tableData" :totalNumber="totalNumber"  @getInsureList="getInsureList" v-loading="loading" class="pt-insure-info-table__withData">
    <template slot="before">
      <slot name="before"/>
    </template>
    <slot/>
  </pt-insure-info-table>
</template>

<script>
import PtInsureInfoTable from './index'
import { insureInfoTableLabels } from '../insure-info'
export default {
  name: 'pt-insure-info-table__withData',
  components: {
    'pt-insure-info-table': PtInsureInfoTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      totalNumber: 0,
      tableData: [],
      page: '',
      tableLabels: insureInfoTableLabels
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getInsureList(this.page)
      },
      deep: true
    }
  },
  methods: {
    getInsureList (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: size || this.pageSize
        }
      }
      this.page = page
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getInsureList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取投保信息失败')
      })
    }
  }
}
</script>
